import {
  Header,
  Layout,
  Listing,
  SEO,
  SliceZone,
  Title,
  Wrapper
} from "components";

import Categories from "../components/Listing/Categories";
import PropTypes from "prop-types";
import React from "react";
import { graphql } from "gatsby";
import styled from "react-emotion";
import website from "../../config/website";
import { Link } from 'gatsby';

const Hero = styled.section`
    background-color: ${props => props.theme.colors.darkBlue};
  `;

const HeroWrapper = styled(Wrapper)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.45rem;
`;

const Headline = styled.h3`
    color: ${props => props.theme.colors.white};
    line-height: 150%;
    width: 80%;
    margin-bottom: 0;
    @media (max-width: ${props => props.theme.breakpoints.m}) {
      width: 100%;
    }
  `;
const BreadCrumb = styled.ul`
  width: 20%;
  color: ${props => props.theme.colors.white};
  font-size: 0.75rem;
  text-align: right;
  margin: 0;
  li {
    display: inline;
  }
  li:not(:first-child):before {
    content:  " > ";
    margin: 0 0.75rem 0 0.75rem;
  }
  a {
    color: ${props => props.theme.colors.white};
    font-style: normal;
  }
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    display: none;
  }
`;

const BodyWrapper = styled(Wrapper)`
  max-width: 740px;
`;

const Post = ({ data: { prismicPost, posts }, location }) => {
  const { data } = prismicPost;
  let categories = false;
  if (data.categories[0].category) {
    categories = data.categories.map(c => c.category.document[0].data.name);
  }

  return (
    <Layout>
      <SEO
        title={`${data.title.text} | ${website._title}`}
        pathname={location.pathname}
        article
      />
      <Header />
      <Hero>
        <HeroWrapper>
          {/* <Header /> */}
          <Headline>
            {/* {data.date} — {categories && <Categories categories={categories} />} */}
            {data.title.text}
          </Headline>
          <BreadCrumb>
            <li><Link to='/'>Home</Link></li>
            <li>Blog</li>
          </BreadCrumb>
        </HeroWrapper>
      </Hero>
      <BodyWrapper>
        <SliceZone allSlices={data.body} />
      </BodyWrapper>
      <Wrapper>
        <Title style={{ marginTop: "2rem" }}>Recent posts</Title>
        <Listing posts={posts.edges} />
      </Wrapper>
    </Layout>
  );
};

export default Post;

Post.propTypes = {
  data: PropTypes.shape({
    prismicPost: PropTypes.object.isRequired
  }).isRequired,
  location: PropTypes.object.isRequired
};

// The typenames come from the slice names
// If this doesn't work for you query for __typename in body {} and GraphiQL will show them to you
// Presently quotes are not read

export const pageQuery = graphql`
  query PostBySlug($uid: String!) {
    prismicPost(uid: { eq: $uid }) {
      uid
      data {
        title {
          text
        }
        date(formatString: "DD.MM.YYYY")
        thumbnail {
          localFile {
            childImageSharp {
              fluid {
                aspectRatio
                src
                srcSet
                sizes
              }
              fixed {
                src
                srcSet
                width
                height
              }
            }
          }
        }
        summary {
          text
        }
        categories {
          category {
            document {
              data {
                name
              }
            }
          }
        }
        body {
          ... on PrismicPostBodyText {
            slice_type
            id
            primary {
              text {
                html
              }
            }
          }
          ... on PrismicPostBodyImage {
            slice_type
            id
            primary {
              image {
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 1200, quality: 90) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              caption {
                text
              }
            }
          }
        }
      }
    }
    posts: allPrismicPost(
      limit: 4
      sort: { fields: [data___date], order: DESC }
    ) {
      edges {
        node {
          uid
          data {
            title {
              text
            }
            thumbnail {
              localFile {
                childImageSharp {
                  fluid {
                    aspectRatio
                    src
                    srcSet
                    sizes
                  }
                  fixed {
                    src
                    srcSet
                    width
                    height
                  }
                }
              }
            }
            summary {
              text
            }
            date(formatString: "DD.MM.YYYY")
            categories {
              category {
                document {
                  data {
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
